/**
 * InventoriesTabs Section Component
 *
 * Renders status filter tabs for the inventory listing.
 * Wraps DataTableTabs with inventory-specific configuration.
 */

import { useMemo } from 'react';
import { DataTableTabs } from '../../DataTable/DataTableTabs';
import type { InventoriesTabsProps, InventoryStatus, InventoryTab, TabsTranslations } from '../types';
import { INVENTORY_STATUS_VALUES, DEFAULT_TAB_LABELS } from '../types';

function buildStatusTabs(translations?: TabsTranslations): InventoryTab[] {
  return INVENTORY_STATUS_VALUES.map((status) => ({
    key: status,
    label: translations?.[status] || DEFAULT_TAB_LABELS[status],
  }));
}

export function InventoriesTabs({
  currentStatus,
  onStatusChange,
  disabled = false,
  translations,
  layoutId,
  className,
}: InventoriesTabsProps) {
  const tabs = useMemo(() => buildStatusTabs(translations), [translations]);

  return (
    <DataTableTabs<InventoryStatus>
      tabs={tabs}
      value={currentStatus}
      onValueChange={onStatusChange}
      disabled={disabled}
      layoutId={layoutId}
      className={className}
    />
  );
}
